import {Navigate, useParams, useSearchParams} from 'react-router-dom'
import {Skeleton} from '@/components/ui/skeleton'
import {NoAccessState} from '@/components/no-access-state'
import {useCapabilities} from '@/hooks/empresa/organizacion/use-businesses'
import {useExpedientes} from '@/hooks/sgsst/evaluacion/use-sgsst'

/** Solo redirige al expediente del año para que los enlaces guardados al historial sigan resolviendo. */
export function SgsstHistoryPage() {
  const {businessId} = useParams()
  const [searchParams] = useSearchParams()
  const canOperate = useCapabilities(businessId).sgsst_operar
  const {data: expedientes, isLoading} = useExpedientes(canOperate ? businessId : undefined)

  if (!canOperate) return <NoAccessState />
  if (isLoading || !expedientes) return <Skeleton className="h-40 w-full" />

  const yearParam = searchParams.get('year')
  const target = yearParam ?? (expedientes[0] ? String(expedientes[0].period_year) : null)

  if (target) return <Navigate to={`/businesses/${businessId}/expediente/${target}`} replace />
  return <Navigate to={`/businesses/${businessId}/sgsst`} replace />
}
